import * as UI from '@brewlogix/blx-ui'
import tailwindConfig from '@brewlogix/blx-ui/tailwind.config'
import classNames from 'classnames'
import React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import { mapStore } from 'src/features/Map/state/mapStore'

interface IListItem {
    theme?: string
    customClasses?: string
    children?: React.ReactNode
    index?: number
    showIndex?: number
    item?: any
    sortable?: boolean
    onEdit?: (index: number, item: any) => void
    isStyled?: boolean
    items?: any[]
    onDelete?: (index: number, item: any) => void
    draggableKey: string
}

const ListItem: React.FC<IListItem> = ({
    customClasses,
    children,
    index,
    sortable = true,
    item,
    isStyled = false,
    draggableKey,
}) => {
    const directionCoordinates = mapStore((state) => state.directionCoordinates)
    const colors = tailwindConfig.theme.colors

    return item ? (
        <Draggable
            key={draggableKey}
            draggableId={draggableKey}
            index={index}
            isDragDisabled={!sortable}
        >
            {(provided) => (
                <div
                    className={classNames(customClasses, 'listItem', !isStyled && 'list-none')}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    <div className='listItem--draggable mr-3 w-fit'>
                        {sortable && <UI.Icon slug='Draggable' size='sm' fill={colors.gray[300]} />}
                    </div>
                    <div className='relative mr-4 h-3 w-3 min-w-[0.75rem] rounded-full border-[3px] border-primary'>
                        <div
                            className={classNames(
                                directionCoordinates?.length - 1 === index ? 'h-[0px]' : 'h-[39px]'
                            )}
                        >
                            <div className='relative left-[2px] top-[14px] h-8 w-2 border-l-2 border-dashed border-gray-200' />
                        </div>
                    </div>
                    {children}
                </div>
            )}
        </Draggable>
    ) : null
}

export default ListItem
